// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDE8XBBP3nlEEtQqUZYyJE8Jk9NoTAhYWk",
  authDomain: "serena-booth.firebaseapp.com",
  projectId: "serena-booth",
  storageBucket: "serena-booth.firebasestorage.app",
  messagingSenderId: "217444123077",
  appId: "1:217444123077:web:a101016957edb274710bac"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const db = getFirestore(app); // ✅ initialize Firestore

export { app, auth, provider, db }; // ✅ export app for AuthContext




